import { render, staticRenderFns } from "./CreateSpaceAfterPayment.vue?vue&type=template&id=4a026b70&"
import script from "./CreateSpaceAfterPayment.vue?vue&type=script&lang=js&"
export * from "./CreateSpaceAfterPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports